<crm-single-select
  #singleSelectComponent
  [options]="entities"
  [(selectedItem)]="_selectedEntity"
  (selectedItemChange)="onSelectNomenclature($event)"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [virtualScroll]="true"
  [virtualScrollItemSize]="50"
  scrollHeight="300px"
  [isTemplateCombined]="true"
  [showClear]="showClear"
  [appendTo]="appendTo"
  filterBy="name"
  panelStyleClass="frm-nomenclature-item-single-select-panel"
  [autoFocusFilter]="true"
  [sort]="''"
  [loading]="loading"
  (onShow)="onShowPanel()"
  (onHide)="onHidePanel()"
  (onFilter)="search($event.filter)">
  <ng-template
    #itemTemplate
    let-item="item">
    <ng-container *ngIf="toNomenclature(item) as nomenclature">
      <div>
        <span [innerHTML]="highlightMatchText(nomenclature.name) | safeHtml"></span>
      </div>
      <div class="frm-color-green">{{ nomenclature.type | nomenclatureTypeName }}</div>
    </ng-container>
  </ng-template>
  <ng-template #emptyTemplate>
    @if (loading) {
      <crm-spinner
        top=""
        text=""
        [height]="35"
        [width]="35"
        bottom=""></crm-spinner>
    } @else {
      Список пуст
    }
  </ng-template>
  <ng-template #footerTemplate>
    @if (paginationLoading) {
      <crm-spinner
        top=""
        text=""
        [height]="35"
        [width]="35"
        bottom=""></crm-spinner>
    }
  </ng-template>
</crm-single-select>
